import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import tripsService from '../../../services/trips/trips.service';
import { useTrips } from '../../contexts/trips-context';
import { IDetailsImage } from '../../places-autocomplete';

export interface ITripDestination {
  placesId?: string;
  googlePlacesId?: string; // Deprecated, use placesId
  latitude?: number;
  longitude?: number;
  name?: string;
  imageUrl?: string;
  images?: IDetailsImage[]; // Update to use IDetailsImage[]
  type?: string;
  types?: string[];
  addressComponents?: any[];
}

export interface IAddTripModel {
  title: string;
  description: string;
  isPublic: boolean;
  imageUrl?: string;
  destinations?: ITripDestination[];
  autoOrganize?: boolean;
  folders?: string[];
  selectedImage?: IDetailsImage;
}

const createInitialTripState = (): IAddTripModel => ({
  title: '',
  description: '',
  isPublic: false,
  imageUrl: 'default.jpg',
  destinations: [],
  autoOrganize: true,
  folders: []
});

export const useAddTrip = (onSuccess?: () => void) => {
  const [trip, setTrip] = useState<IAddTripModel>(createInitialTripState());
  const { setRefreshTrips } = useTrips();
  const navigate = useNavigate();
  const validated = trip.title.trim().length > 0;

  const handleInputChange = (field: keyof IAddTripModel, value: any) => {
    setTrip((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      console.log('Trip data:', trip);
      const result = await tripsService.createTrip(trip);
      const createdTripId =
        result?.data?.id || result?.id || result?.data?._id || result?._id;

      setRefreshTrips(true);
      setTrip(createInitialTripState());
      onSuccess?.();

      if (createdTripId) {
        navigate(`/app/trip/${createdTripId}/view/discovery`);
      } else {
        alert('Trip created, but it could not be opened automatically.');
      }
    } catch (error: any) {
      console.error('Error creating trip:', error);
      const message =
        error?.message ||
        error?.error ||
        error?.response?.data?.message ||
        'An error occurred while creating the trip';
      alert(message);
    }
  };

  return {
    trip,
    validated,
    handleInputChange,
    handleSubmit
  };
};
